export default "__VITE_ASSET__CcVgsITu__"